import { WeekTimeRecordsScope } from "@planzone/dto";
import { State } from "./types";

function toScopeKey(scope: WeekTimeRecordsScope): string {
  return Object.entries(scope)
    .map(([key, value]) => `${key}:${value}`)
    .join("|");
}

function matchRequest(
  req: State[number],
  scope: WeekTimeRecordsScope,
  startDate: string,
  endDate: string,
): boolean {
  return (
    toScopeKey(req.scope) === toScopeKey(scope) &&
    req.startDate === startDate &&
    req.endDate === endDate
  );
}

export { matchRequest };
